import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { loadPageData } from 'redux/actions/Request';

import { makeStyles } from '@material-ui/core/styles';

import { 
  Chip,
  List,
  Fade,
  Dialog,
  Button,
  ListItem,
  DialogTitle,
  ListItemText,
  DialogContent,
} from '@material-ui/core';

import PublicIcon from '@material-ui/icons/Public';
import DeleteIcon from '@material-ui/icons/Delete';

import { isGlobal, isMicrosoft } from './helpers'

import SearchField from './SearchField';

const useStyles = makeStyles((theme) => ({
  formControl: {
    height: 80,
    padding: 0,
    marginRight: 5
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  card: {
    marginBottom: theme.spacing(2)
  },
  dFlex: {
   display: 'flex',
   alignItems: 'flex-start'
  },
  formGrid : {
    height: 400,
    overflowY: 'auto'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  filterPaper: {
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    height: '32px', // Hack fixed height until i can figure out a better way of handling this
    width: '100%'
  },
  searchFieldChip: {
    maxWidth: '80vw',
    marginRight: theme.spacing(0.5),
  },
  expandButton: {
    marginLeft: 'auto',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  cardAction: {
    marginRight: theme.spacing(1)
  },
  savedQueries: {
    padding: theme.spacing(1),
  },
  savedQueriesSearch: {
    justifyContent: 'flex-end',
    display: 'flex'
  },
  savedQueriesList: {
    overflowY: 'auto',
  },
  toolBar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  titleBar: {
    marginRight: theme.spacing(2),
  },
  dataSource: {
    '& input': {
      height: 28
    }
  },
  confirmContainer: {
    width: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& p': {
      margin: 0,
      color: theme.palette.text.secondary
    }
  },
  confirmDelete: { 
    color: 'red',
  },
  savedReportBtnContainer: {
    display: 'flex',
    '& svg': {
      marginLeft: theme.shape.padding
    }
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.divider}`
  }
}));

const SavedQueryModal = (props) => {
  const [savedQueries, setSavedQueries] = useState([])
  const [modelToDelete, setModelToDelete] = useState(false)
  const [savedQueryFilter, setSavedQueryFilter] = useState([])
  const [isDeletingQuery, setIsDeletingQuery] = useState(false)

  const classes = useStyles();

  useEffect(() => {
    const filter_ranked = props.queries.map(q=>{return{model:q, match:savedQueryFilter.filter(s=>q.name.toLowerCase().includes(s)).length}})
    filter_ranked.sort((a,b)=> a.match>b.match ? -1: 1)
    
    // set query list with only matched items
    if(savedQueryFilter.length)
      setSavedQueries(filter_ranked.filter(sq => sq.match > 0))
    else
      setSavedQueries(filter_ranked)

    // when queries are reloaded
    // ensure delete UI is reset
    setIsDeletingQuery(false)

  }, [props.queries, savedQueryFilter])

  const filterReports = (queries) => {
    if(props.license.isTagged('limited-to-microsoft')){
      return queries.filter(o=>isGlobal(o)).filter(o=>isMicrosoft(o.model))
    }
    return queries
  }

  const onClick = (savedQuery) => {
    props.onClick(savedQuery)
    props.onClose()
  }

  const handleCancel = (e) => {
    e.stopPropagation()
    setModelToDelete(false)
  }

  const handleDeleteQuery = (e) => {
    e.stopPropagation()
    if(!modelToDelete){
      return
    }
    setIsDeletingQuery(true)
    modelToDelete.delete()
    .then(() => {
      props.reload(true)
    })
    .catch(e => {
      setIsDeletingQuery(false)
    })
  }

  const toggleConfirmDelete = (e, model) => {
    e.stopPropagation()
    setModelToDelete(model)
  }

  return (
    <Dialog disableScrollLock={true} onClose={props.onClose} aria-labelledby="saved-queries-dialog-title" open={props.show} fullWidth={true} maxWidth="md" datacy={'loadSavedReportsModal'}>
      <DialogTitle id="saved-queries-dialog-title">Saved Reports</DialogTitle>
      <DialogContent>
        <SearchField value={savedQueryFilter} onChange={setSavedQueryFilter} />
        <List className={classes.savedQueriesList}>
          {savedQueries.length > 0 && filterReports(savedQueries).map((sortedEntry)=>(
            <ListItem key={`saved_query_${sortedEntry.model.id}`} button onClick={()=>onClick(sortedEntry.model)} className={classes.listItem} datacy={'loadSavedReportsItem'}>
              <ListItemText primary={sortedEntry.model.name} /*secondary={sortedEntry.model.aggregate.join(", ")}*/ />
              {isGlobal(sortedEntry.model) ? 
                <Chip icon={<PublicIcon />} label={'Global'} />: // OR
              (modelToDelete && modelToDelete.id === sortedEntry.model.id) ? 
                <Fade in={modelToDelete.id === sortedEntry.model.id} timeout={500}>
                  <div className={classes.confirmContainer}>
                    {!isDeletingQuery &&<p>are you sure?</p>}
                    <Button disabled={isDeletingQuery} variant={'text'} className={classes.confirmDelete} onClick={handleDeleteQuery} datacy={'deleteReportButton'}>
                      {isDeletingQuery ? 'deleting...' : 'delete report'}
                    </Button>
                    {!isDeletingQuery && <Button variant={'text'} color={'primary'} onClick={handleCancel}>cancel</Button>}
                  </div>
                </Fade> : // OR
                <div className={classes.savedReportBtnContainer}>
                  <DeleteIcon color={'primary'} onClick={e => toggleConfirmDelete(e, sortedEntry.model)} datacy={'deleteReportIcon'}/>
                </div>
              }
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    reload: (force)=>dispatch(loadPageData(force))
  }
}

// ** State constants *****************
const mapStateToProps = (state) => {
  return {
    license: state.license
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedQueryModal)